import { lazy, Suspense } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useFeatures } from 'modules/core/hooks/useFeatures'

const LegacyDataTable = lazy(() => import('./LegacyDataTable'))
const DocumentsDataCollection = lazy(() => import('./DataCollection'))

const LoadingFallback = () => (
  <Box alignItems="center" padding="s64">
    <Spinner />
  </Box>
)

const EmployeeDocumentsDataTable = () => {
  const { has_dev_documents_data_collection } = useFeatures(['dev_documents_data_collection'])

  return (
    <Suspense fallback={<LoadingFallback />}>
      {has_dev_documents_data_collection ? <DocumentsDataCollection /> : <LegacyDataTable />}
    </Suspense>
  )
}

export default EmployeeDocumentsDataTable
